<template>
  <b-form class="1w-100 form" @submit="onSubmit">
    <b-row cols="1">
      <b-col>
        <b-form-group label="Valor:" label-for="value">
            
          <b-form-input :state="validationAmout" 
            id="amount"
            v-model.lazy="form.amount"
                  v-money="money"
            required
            placeholder="Valor"
          ></b-form-input>
            <b-form-invalid-feedback :state="validationAmout">
         O Valor  precisa ser maior que 0 
      </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group label="Descrição:" label-for="description">
          <b-form-input
            id="description"
            v-model="form.description"
            required
            placeholder="Descrição"
           
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group label="Data de pagamento " label-for="paymentDate">
        <a-date-picker
        
                        :v-model="form.paymentDate"
                        :default-value="moment(moment(), dateFormat)"
                        :format="dateFormat"
                        @change="handleCalendarChange"
                      />
        </b-form-group>
      </b-col>

 <b-col >
         <b-form-group  required label="Tipo de Fatura">
        <!--   <b-spinner
            v-if="!invoiceTypes.length"
            variant="primary"
            label="Spinning"
          ></b-spinner> -->
               <a-select   default-value="" v-model="form.idInvoiceType">
                <a-select-option value="">
                  Selecione
                </a-select-option>
                <a-select-option
                  :value="item.id"
                  v-for="(item, index) in invoiceTypes"
                  :key="`invoiceTypeId-${index}`"
                >
                  {{ item.description }}
                </a-select-option>
              </a-select>
              </b-form-group>
      </b-col>

    

 <b-col>
        <b-form-group label="Estabelecimento:" label-for="ec">
        
                <v-select
                required
                  label="name"
                  :filterable="false"
                  :options="merchants"
                  :reduce="(merchant) => merchant.id"
                  v-model="form.idMerchant"
                  @search="onSearch"
                >
                  <template slot="no-options"
                    >Pesquisar Estabelecimento</template
                  >
                  <template slot="option" slot-scope="option">{{
                    option.name
                  }}</template>
                  <template slot="selected-option" slot-scope="option">{{
                    option.name
                  }}</template>
                </v-select>
            
         </b-form-group>
      </b-col>


      <b-col v-if="sysAdminUser" class="col-md-4">
        <b-form-group label="Canal de Venda:" label-for="idSaleChannel">
          <a-select required v-model="form.idSaleChannel">
            <a-select-option value="">
              Selecione
            </a-select-option>
            <a-select-option
              :value="item.id"
              v-for="(item, index) in salechannels"
              :key="`salechannel-${index}`"
            >
              {{ item.description }}
            </a-select-option>
          </a-select>
        </b-form-group>
      </b-col>
    </b-row>

    <hr />

    <div class="row">
      <b-btn
        type="submit"
        class="col-md-2 ml-3 mt-2"
        variant="outline-primary"
        :disabled="loading"
        >Salvar
        <b-spinner
          small
          variant="primary"
          label="Spinning"
          v-show="loading"
        ></b-spinner>
      </b-btn>
    </div>
  </b-form>
</template>

<script>
import { get as _get, debounce as _debounce } from "lodash";
InvoiceResource
import { InvoiceResource } from "@/resources/Invoice.resource.js";
import { InvoiceTypeResource } from "@/resources/InvoiceType.resource.js";
import moment from "moment";
import { MaskUtils } from "@/utils/MaskUtils.js";
import { mask } from "@titou10/v-mask";
import { VMoney } from "v-money";
import { mapState, mapGetters } from "vuex";

export default {
  directives: { mask, money: VMoney  }, 
  props: {
    invoice: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },

  data() {
    return {
      loading: false,
      form: {
        description: _get(this.invoice, "description", ""),
        amount: _get(this.invoice, "amount", "0"),
        id: _get(this.invoice, "idInvoice", "0"),
        paymentDate : moment(moment(), "DD/MM/YYYY"), 
      
        idSaleChannel: (_get(this.invoice, "idSaleChannel", null)),
         idInvoiceType: (_get(this.invoice, "idInvoiceType", null)),
        idMerchant: _get(this.invoice, "idMerchant", "")
      },
      dateFormat: "DD/MM/YYYY",
      monthFormat: "YYYY/MM",
        merchants: [],
      salechannels: [],
      invoiceTypes: [],
       money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: true,
      },
    };
  },

  computed: {
    ...mapGetters({
      getFrontEndVersion: "getFrontEndVersion",
      getConfig: "getConfig"
    }),

    validationAmout() {
      if (this.form.amount === null) {
        return null;
      }
      return this.$unmaskMoney(this.form.amount) >0 ;
    },
    sysAdminUser() {
      try {
        return (
          this.$store.getters.user.role
            .split(",")
            .filter(role => role === "SystemAdmin").length > 0
        );
      } catch (e) {
        return false;
      }
    },

    getIdSaleChannel() {
      if (!this.sysAdminUser) {
        return this.getConfig.idSaleChannel;
      }
      return this.form.idSaleChannel;
    }
  },
  methods: {

    moment,
    handleCalendarChange(date) {
      this.form.paymentDate = date;
    },

       onSearch(search, loading) {
      loading(true);
      this.search(loading, search, this);
    },

    search: _debounce((loading, search, vm) => {
      vm.$api
        .get("v1/merchant/keyvalue", {
          params: {
            name: search,
          },
        })
        .then((result) => {
          loading(false);
          vm.merchants = result.data.payload.map((item) => ({
            id: item.id,
            name: item.description,
          }));
        })
        .catch((e) => {
          // Surpress
        });
    }, 350),

    getSalechannels() {
      this.$api
        .get("v1/salechannel/keyvalue")
        .then(result => {
          this.salechannels = result.data.payload;
        })
        .catch(e => {
          // Surpress
        });
    },

    getInvoiceTypes() {
      InvoiceTypeResource.getKeyValue()
        .then(response => {
          if (response.data.isSuccess) {
            this.invoiceTypes = response.data.payload;
          } else {
            throw "erro ao carregar invoice types";
          }
        })
        .catch(e => {
          // Surpress
        });
    },

     

    async onSubmit(e) {
      e.preventDefault();
      
       this.form.idSaleChannel = this.getIdSaleChannel;
      const data = {
        ...this.form,
        idAcquirer :1, 
        idInvoice:
          parseInt(this.$route.params.id) > 0
            ? parseInt(this.$route.params.id)
            : 0
      };

      this.loading = true;
      const vm = this;

      data.amount = this.$unmaskMoney(data.amount);
     data.paymentDate  = data.paymentDate.format("YYYY-MM-DDT00:00:00");
     
      if (data.id == 0) {
        InvoiceResource.register(data)
          .then(result => {
            try {
              vm.loading = false;
              this.$notification["success"]({
                message: "Registro inserido",
                description: ""
              });

              this.loading = false;
              this.$router.push("/invoice");
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada..."
                  }
                }
              };
            }
          })
          .catch(e => {

            this.$notification["error"]({
                message: "Por favor, confira se os campos estão devidamente preenchidos",
                description: ""
              });
            // Surpress
            this.loading = false;
          });
      } else {
        InvoiceResource.update(data)
          .then(result => {
            try {
              vm.loading = false;
              this.$notification["success"]({
                message: "Registro atualizado",
                description: ""
              });

              this.loading = false;
              this.$router.push("/invoice");
            } catch (e) {
              throw {
                response: {
                  data: {
                    failureReason: "Deu ruim na chamada..."
                  }
                }
              };
            }
          })
          .catch(e => {
            // Surpress
            this.loading = false;
          });
      }
    }
  },
  created() {
    // primeiro momento da pagina, carrega os dados dos filtros...
    // verificar o quanto estes dados mudam para fazer um cache no vuex....
    this.getSalechannels();
    this.getInvoiceTypes();
  }
};
</script>

<style lang="css">
.width-150 {
  width: 150px;
}
.form .is-invalid,
.form .is-valid {
  padding-right: 0;
}
</style>
